import trackEvent from "@analytics/utils/trackEvent";

const OrganizationsAnalyticsService = {
  technologyAssigned: () => trackEvent("Technology Assignee Updated"),
  userRemoved: (name: string, userAccountId: string) => trackEvent("User Removed", { name, userAccountId }),
} as const;

export default OrganizationsAnalyticsService;
